/**
 * Globally registered components
 *
 * These components can be used anywhere and do not need to be imported into individual files
 *
 * Import this file in main.ts
 *
 */

import BackButton from "@/components/elements/utility/BackButton.vue";
import PageHeadline from "@/components/elements/utility/PageHeadline.vue";
import NoteModal from "@/components/elements/modal/NoteModal.vue";
import HeroIcon from "@/components/elements/icons/HeroIcon.vue";

import Vue from "vue";

Vue.component("BackButton", BackButton);
Vue.component("PageHeadline", PageHeadline);
Vue.component("NoteModal", NoteModal);
Vue.component("HeroIcon", HeroIcon);
